<template>
  <Card :title="name[locale]" :translate="false" containerClass="mb-5 shadow-sm">
    <template #cardBody>
      <CKEditor
        :id="`${id}_ck_editor`"
        :required="true"
        :label="$t('setting.label')"
        :content="notes"
        @text="getNote"
        class="custom-ckeditor"
        ref="ckeditor"
        @ready="onEditorReady"
      />    
      <br>
      <div class="card-toolbar d-flex justify-content-end mt-10">
       <ButtonDropdown
          :btn-title="$t('addVariable')"
          :search="false"
          :options="mailEnum"
          value-field="value"
          :name-field="locale"
          v-model="selectedVariable"
          :border="true"
          :showIcon="true"
          icon="fas fa-plus"
          :hideAngle="false"
        />   
        <Button v-if="$can(abilities.EMAIL_CONFIG_CREATE)" btn-class="btn-sm" type="new" id="submit_btn" btn-text="setting.button" @click="updateMailData" :isLoading="isLoading"></Button>
      </div>
    </template>
  </Card>
</template>

<script setup>
import Card from "@/Modules/CRM/components/Card.vue";
import CKEditor from "@/components/CKEditor.vue";
import {useStore} from "vuex";
import {ref, defineProps, watch, nextTick} from 'vue'
import { useLocales } from "@/composables/locales";
import Button from "@/components/Button"
import ButtonDropdown from "@/components/OutlineButtonDropdown.vue";
import abilities from "@/composables/abilities";

const {locale} = useLocales()

const store = useStore()

const props = defineProps({
  id: {
    type: String,
  },
  name: {
    type: String,
  },
  mail: { 
    type: String, 
  },
  mailId: {
    type: String,
  } ,
  mailEnum: Array
}) 

const notes = ref(props.mail)
const selectedVariable = ref('')
const ckeditor = ref(null);
const isLoading = ref(false)

function updateMailData() {
  isLoading.value = true
  store.dispatch('mail/updateMail',{content:notes.value, id: props.mailId}) 
    .then((response) => {
      window.toastr['success'](i18n.global.t('setting.setting_message'));
      isLoading.value = false
    })
    .catch(err => {
      isLoading.value = false
    });
}

function onEditorReady(editor) {
  ckeditor.value.editorInstance = editor;
}

function getNote(text) {
  notes.value = text
}

watch(() => selectedVariable.value, (value) => {
  nextTick(() => {
    if(value) insertVariable()
  })
})

function insertVariable(){
  if (!ckeditor.value || !ckeditor.value.editorInstance) return;

  const editor = ckeditor.value.editorInstance;
  const variableText = selectedVariable.value;

  editor.model.change(writer => {
    const insertPosition = editor.model.document.selection.getFirstPosition();
    writer.insertText(variableText, insertPosition);
  });
}

</script>
<style scoped>
.custom-card {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1), 
              0px 0px 3px rgba(241, 238, 238, 0.1), 
              0px 0px 3px rgba(241, 238, 238, 0.1), 
              0px 0px 3px rgba(241, 238, 238, 0.1);
  border-radius: 12px;
}

.custom-card .card-header {
  border-bottom: 0px solid #f1f1f1; 
  border-radius: 12px 12px 0 0;
}

.custom-card .card-body {
  padding: 20px; 
  border-radius: 0 0 12px 12px;
}

.custom-ckeditor {
  height: 400px; 
}
</style>
